module.exports = __webpack_public_path__ + "img/xuanchuan3.ea202ef6.png";